const Modernizr = require('modernizr')

const loadResponsiveImages = () => {
    if (!Modernizr.objectfit) {
        const responsiveImages = document.querySelectorAll('.responsive-image')

        for (let i = 0; i < responsiveImages.length; i++) {
            const image = responsiveImages[i].querySelector('img')
            const imageUrl = image ? image.getAttribute('src') : null

            if (imageUrl) {
                responsiveImages[i].style.backgroundImage = `url(${imageUrl})`
                responsiveImages[i].querySelector('img').style.opacity = 0
            }
        }
    }
}

export default loadResponsiveImages



// WEBPACK FOOTER //
// ./js/responsiveImages.js